import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home'

import Actualidad from '@/components/views/actualidad'
import FichaNoticia from '@/components/views/ficha-noticia'


import alumnosyalumni from '@/components/views/alumnos-y-alumni'
import conectados from '@/components/views/conectados'
import empresas from '@/components/views/empresas'
import faqs from '@/components/views/faqs'
import observatorio from '@/components/views/observatorio'
import buscadorrecursos from '@/components/views/buscador-recursos'
import buscadorrecursosinternacional from '@/components/views/buscador-recursos-internacional'
import internacional from '@/components/views/alumni-internacional'
import guia from '@/components/views/guia'
import orientacion from '@/components/views/orientacion'
import equipo from '@/components/views/equipo'


import aldia from '@/components/views/al-dia'

import Contacto from '@/components/views/contacto'


import Error404 from '@/components/views/error-404'


Vue.use(Router)


import messages from '@/translations';

let en = messages.en.enlaces;
let es = messages.es.enlaces;

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
			meta : {
				title : 'Departamento de Carreras Profesionales UFV',
				description : "Nuestra misión es acompañar a los alumnos y antiguos alumnos de la universidad francisco de vitoria en las decisiones sobre su carrera profesional."
			}
		},

		{
			path: `${es.aldia}/:id`,
			name: 'ficha-noticia',
			component: FichaNoticia
		},
		{
			path: `${es.eventos}/:id`,
			name: 'ficha-evento',
			component: FichaNoticia
		},
		{
			path: `${es.recursos}/:id`,
			name: 'ficha-recurso',
			component: FichaNoticia
		},
		{
			path: es.alumnos,
			name: 'alumnos',
			component: alumnosyalumni,
			meta : {
				title : 'Servicio a estudiantes y antiguos alumnos  con prácticas y empleo',
				description : "Las prácticas en empresas son una valiosa oportunidad de formación. Y si eres alumni accede a ofertas y orientación de desarrollo de la carrera profesional"
			}
		},
		{
			path: es.empresas,
			name: 'empresas',
			component: empresas,
			meta : {
				title : 'Relación de empresas e instituciones con UFV, conoce nuestro proyecto formativo.',
				description : "Gestionamos la publicación de ofertas y puesta a disposición de perfiles de estudiantes y alumni UFV, así cómo información sobre cómo colaborar."
			}
		},
		{
			path: es.observatorio,
			name: 'observatorio',
			component: observatorio,
			meta : {
				title : 'Informes y publicaciones sobre empleabilidad ',
				description : "Centro de recogida de datos sobre las características más notables de la inserción laboral de titulados UFV"
			}
		},
		{
			path: es.internacional,
			name: 'internacional',
			component: internacional,
			meta : {
				title : 'Orientación y asesoramiento para el empleo y prácticas fuera de España.',
				description : "Asesoramiento y ayuda , programas y convocatorias para realizar prácticas o acceder a empleo en el entorno internacional."
			}
		},
		{
			path: es.orientacion,
			name: 'orientacion',
			component: orientacion,
			meta : {
				title : 'Protagoniza tu futuro',
				description : "Ponemos a tu disposición un Programa de Acompañamiento para el inicio de tu Carrera Profesional. Así como información sobre empresas, salidas profesionales y recursos."
			}
		},
		{
			path: es.equipo,
			name: 'equipo',
			component: equipo,
			meta : {
				title : 'Equipo Carreras Profesionales UFV',
				description : "Formamos, orientamos y acompañamos a los alumnos y antiguos alumnos en el inicio de su carrera profesional."
			}
		},
		{
			path: `${es.buscadorrecursos}/:id?`,
			name: 'buscadorrecursos',
			component: buscadorrecursos,
			meta : {
				title : 'Protagoniza tu futuro',
				description : "Ponemos a tu disposición un Programa de Acompañamiento para el inicio de tu Carrera Profesional. Así como información sobre empresas, salidas profesionales y recursos."
			}
		},
		{
			path: `${es.buscadorrecursosinternacional}/:id?`,
			name: 'buscadorrecursosinternacional',
			component: buscadorrecursosinternacional,
			meta : {
				title : 'Protagoniza tu futuro',
				description : "Ponemos a tu disposición un Programa de Acompañamiento para el inicio de tu Carrera Profesional. Así como información sobre empresas, salidas profesionales y recursos."
			}
		},
		{
			path: `${es.guia}/:id?`,
			name: 'guia',
			component: guia,
			meta : {
				title : 'Protagoniza tu futuro',
				description : "Ponemos a tu disposición un Programa de Acompañamiento para el inicio de tu Carrera Profesional. Así como información sobre empresas, salidas profesionales y recursos."
			}
		},
		{
			path: es.aldia,
			name: 'aldia',
			component: aldia,
			meta : {
				title : 'Noticias y eventos',
				description : "Actividades programadas o de las que se hace eco el Departamento de Carreras Profesionales UFV UFV"
			}
		},
		{
			path: `${es.conectados}/:id?`,
			name: 'conectados',
			component: conectados,
			meta : {
				title : 'Programa para el contacto entre estudiantes y alumni UFV coon profesionales con experiencia',
				description : "Ante dudas en las decisiones sobre la carrera profesional,  ponemos en contacto a los alumnos de UFV con profesionales que pueden ayudarles."
			}
		},

		{
			path: es.contacto,
			name: 'contacto',
			component: Contacto,
			meta : {
				title : 'Formulario de contacto Departamento Prácticas y Empleo UFV',
				description : "Escríbenos si tienes cualquier duda o consulta, nuestro equipo se pondrá en contacto contigo para resolver tus dudas."
			}
		},

		
		{ path: '*', redirect: '/404' },
		{ path: "/404", component: Error404 }
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
});

import VueAnalytics from 'vue-analytics';


Vue.use(VueAnalytics, {
	id: 'UA-87588846-2',
	router,
	disabled: !(document.cookie.includes('cookieyes-analytics=yes') && document.cookie.includes('cky-consent=yes') ),
	debug: { sendHitTask: location.hostname.includes('practicasempleo-ufv.es') }
});

router.beforeEach((to, from, next) => {

	console.log(to.meta);

	if (!!to.meta) {
		if (!!to.meta.title) {
			document.title = to.meta.title
			document.head.querySelector("[name=description]").content = to.meta.description;
			document.head.querySelector("[property='og:title']").content = to.meta.title
			document.head.querySelector("[name='twitter:title']").content = to.meta.title
			document.head.querySelector("[property='og:description']").content = to.meta.description;
			document.head.querySelector("[name='twitter:description']").content = to.meta.description;
		}
	}

	next()
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js